import React from 'react';
import { useTranslation } from 'react-i18next';

import { Avatar, AvatarGroup } from '@chakra-ui/react';
import { faCalendarCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import theme from 'styles/themes/default';
import { formatShortDate, formatTimeFromTimestamp } from 'utils/dateFormat';

import { useUser } from 'hooks/useUser';

import Block from 'components/atom/Block';
import Text from 'components/atom/Text/styles';

import { BoxTable, Container, Content, FooterCard, HeaderCard } from './styles';

interface ICardMeetingProps extends IMatchmakingInvitation {
  setInvitation: () => void;
}

const CardMeeting: React.FC<ICardMeetingProps> = ({
  fullname,
  companyName,
  avatar,
  eventSlug,
  date,
  setInvitation,
}) => {
  const { t } = useTranslation();

  const {
    user: { avatar: userAvatar, fullname: userName },
  } = useUser();

  return (
    <Block>
      <Container onClick={() => setInvitation()}>
        <HeaderCard>
          <FontAwesomeIcon icon={faCalendarCheck} />

          <Text weight="900" size={22} lineHeight={22} color={theme.colors.dark.color}>
            {formatShortDate(date)} - {formatTimeFromTimestamp(date).replace(':', 'h')}
          </Text>
        </HeaderCard>

        <Content>
          <Text weight="bold" p16 lineHeight={26}>
            {`${t('meetings:meeting.meetingWith')} ${fullname}`}
          </Text>

          <Text weight="bold" lineHeight={20} color={theme.colors.texts_light}>
            {companyName}
          </Text>
        </Content>

        <hr />

        <FooterCard>
          <AvatarGroup size="sm" max={2}>
            <Avatar name={userName} src={userAvatar} />
            <Avatar name={fullname} src={avatar} />
          </AvatarGroup>

          <BoxTable>SET Centro-Oeste</BoxTable>

          {eventSlug && (
            <Text weight="bold" lineHeight={20}>
              {eventSlug}
            </Text>
          )}
        </FooterCard>
      </Container>
    </Block>
  );
};

export default CardMeeting;
